import React from 'react';
import { Box, TextField, FormControlLabel, Switch } from '@mui/material';
import { MASKED_PLACEHOLDER } from '../../constants';

const MinIOSourceForm = ({ name, config, errors, onChange, isEdit }) => {
    const handleChange = (field, value) => {
        if (field === 'name') {
            onChange({ name: value, config });
            return;
        }
        const next = { ...config, [field]: value };
        onChange({ name, config: next });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
                fullWidth
                label="Tên hiển thị"
                required
                value={name}
                onChange={(e) => handleChange('name', e.target.value)}
                error={!!errors?.name}
                helperText={errors?.name}
            />
            <TextField
                fullWidth
                label="Endpoint"
                required
                value={config?.endpoint ?? ''}
                onChange={(e) => handleChange('endpoint', e.target.value)}
                placeholder="localhost:9000 hoặc minio.example.com"
            />
            <TextField
                fullWidth
                label="Access Key"
                value={config?.access_key ?? config?.accessKey ?? ''}
                onChange={(e) => handleChange('access_key', e.target.value)}
            />
            <TextField
                fullWidth
                label="Secret Key"
                type="password"
                autoComplete="new-password"
                value={config?.secret_key === '***' || config?.secret_key === MASKED_PLACEHOLDER ? '' : (config?.secret_key ?? config?.secretKey ?? '')}
                onChange={(e) => handleChange('secret_key', e.target.value)}
                placeholder={isEdit ? MASKED_PLACEHOLDER : ''}
                helperText={isEdit && 'Để trống nếu không đổi'}
            />
            <TextField
                fullWidth
                label="Bucket (tùy chọn)"
                value={config?.bucket ?? ''}
                onChange={(e) => handleChange('bucket', e.target.value)}
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={config?.secure !== false}
                        onChange={(e) => handleChange('secure', e.target.checked)}
                    />
                }
                label="Dùng HTTPS"
            />
        </Box>
    );
};

export default MinIOSourceForm;
